import { isSafeNumber } from './isSafeNumber';
/**
 * Valida si una cadena es un numero valido.
 *
 * Para validar un tipo 'number', usar ../isNumber.
 * Para aceptar tipos "string" y "number", usar ../isValidNumber
 *
 * @param {string}
 * @return {boolean}
 */

export function isValidNumber(str) {
  if (typeof str !== 'string') {
    throw new Error(`str must be a "string" and not typeof "${typeof str}"`);
  }

  return isSafeNumber(str);
}
